module.exports = __webpack_public_path__ + "static/img/header-logo.b952539.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/header-logo.png
// module id = Mv+x
// module chunks = 1